import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
/**
 * @description A class to round one or more corners of an image or video.
 * @extends SDK.Action
 * @memberOf Actions.RoundCorners
 * @see Visit {@link Actions.RoundCorners|RoundCorners} for an example
 */

var RoundCornersAction = /*#__PURE__*/function (_Action) {
  _inherits(RoundCornersAction, _Action);

  var _super = _createSuper(RoundCornersAction);

  function RoundCornersAction() {
    _classCallCheck(this, RoundCornersAction);

    return _super.call(this);
  }
  /**
   * @param {number} a
   * @param {number} b
   * @param {number} c
   * @param {number} d
   * @return {RoundCornersAction}
   */


  _createClass(RoundCornersAction, [{
    key: "radius",
    value: function radius(a, b, c, d) {
      var qualifierValue = new QualifierValue(); // In case a === 0, check typeof

      typeof a !== undefined && qualifierValue.addValue(a);
      typeof b !== undefined && qualifierValue.addValue(b);
      typeof c !== undefined && qualifierValue.addValue(c);
      typeof d !== undefined && qualifierValue.addValue(d);
      this.addQualifier(new Qualifier('r').addValue(qualifierValue));
      return this;
    }
    /**
     * @description Applies maximum rounding to the corners of the asset. An asset with square dimensions becomes a circle.
     */

  }, {
    key: "max",
    value: function max() {
      return this.addQualifier(new Qualifier('r', 'max'));
    }
  }]);

  return RoundCornersAction;
}(Action);

export default RoundCornersAction;